import React from 'react'
import PropTypes from 'prop-types'

const PressTabletOrDesktop = ({ languageUrl, languageUrlSwitchForPress }) => {
  return (
    <div className='not-responsive-flex tablet'>
      {languageUrlSwitchForPress(languageUrl).map(pressSVG => (
        <div key={pressSVG.index} className='press-svg-container'>
          <img src={pressSVG.src} alt={pressSVG.alt} width={pressSVG.width} height={pressSVG.height} />
        </div>
      ))}
    </div>
  )
}

PressTabletOrDesktop.propTypes = {
  languageUrl: PropTypes.string,
  languageUrlSwitchForPress: PropTypes.func
}

export default PressTabletOrDesktop
